import script from "./HrSeverityLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSeverityLabel.vue?vue&type=script&setup=true&lang=js"

import "./HrSeverityLabel.vue?vue&type=style&index=0&id=619bc488&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619bc488"]])

export default __exports__